var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(this.more.name != '')?_c('el-link',{attrs:{"href":this.more.url,"target":"_blank","underline":false}},[_vm._v(" "+_vm._s(this.more.name))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }